// src/components/RecipeCard.js
import React from 'react';

const RecipeCard = ({ recipe }) => {
  return (
    <div className="card">
      <h3>{recipe.name}</h3>
      <p>{recipe.description}</p>
      <button onClick={() => console.log('Recipe details')}>View Recipe</button>
    </div>
  );
};

export default RecipeCard;
